import { render, staticRenderFns } from "./TaskReceive.vue?vue&type=template&id=18e8d9f0&scoped=true&"
import script from "./TaskReceive.vue?vue&type=script&lang=js&"
export * from "./TaskReceive.vue?vue&type=script&lang=js&"
import style0 from "./TaskReceive.vue?vue&type=style&index=0&id=18e8d9f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18e8d9f0",
  null
  
)

export default component.exports